<template>
    <div>
        <router-link :to="{name: 'userCreate'}" class="btn btn-success btn-sm mb-2">New user</router-link>
        <filter-global-input class="pull-right"/>
        <div class="card">
            <div class="card-body card-table">
                <vue-good-table
                        :columns="columns"
                        :isLoading.sync="isLoading"
                        :pagination-options="{enabled: true}"
                        :rows="table.rows"
                        :styleClass="'table'+((!isCLoading) ? ' table-hover' : '')"
                        :totalRows="table.totalRecords"
                        @on-column-filter="onColumnFilter"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        mode="remote">
                    <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'name'">
                    <router-link :to="{name: 'userUpdate', params: {id: props.row.id}}">{{props.row.name}}</router-link>
                </span>
                        <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
                    </template>
                    <div slot="emptystate">
                        <span v-if="isCLoading">
                            <loader-table></loader-table>
                        </span>
                        <span v-else>
                            {{$t('table.NoData')}}
                        </span>
                    </div>
                    <template slot="loadingContent">
                        <div class="spinner-border text-secondary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>
<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import {VueGoodTable} from 'vue-good-table';
    import {mapActions, mapGetters} from 'vuex'
    import loaderTable from '@/components/charts/loaders/loader-table.vue'
    import FilterGlobalInput from '@/components/FilterGlobalInput'

    export default {
        name: 'measurementIndex',
        data() {
            return {
                isLoading: false,
                isCLoading: true,
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                    },
                    {
                        label: 'Email',
                        field: 'email',
                    },
                    {
                        label: 'Roles',
                        field: 'roles',
                        // field: function (roles) {
                        //     return (roles.roles[0]) ? roles.roles[0].name : ''
                        // },
                    }
                ]
            };
        },
        computed: mapGetters({
                table: 'TABLE'
            }
        ),
        components: {
            VueGoodTable,
            loaderTable,
            FilterGlobalInput
        },
        async mounted() {
            this.$store.dispatch('TO_DEFAULTSTATE')
            await this.loadItems()
            this.isCLoading = false
        },
        methods: {
            ...mapActions({
                    loadItems: 'GET_USERS',
                }
            ),
            updateParams(newProps) {
                this.$store.dispatch('CHANGE_SERVERPARAMS', newProps)
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                let type = params[0].type
                let field = params[0].field

                this.updateParams({
                    sort: [{
                        type: type,
                        field: field,
                    }],
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            }
        }
    }
</script>
<style>
    .vgt-wrap__footer {
        color: #ffffff;
        padding: 0.5em !important;
        border: none !important;
        border-top: 1px solid #dcdfe6 !important;
        background: #ffffff !important;
    }
</style>
